import type { UserEntity } from "@/shared/types/user.entity";

import { NOTES_CREATE_SCOPES, NOTES_MODERATE_SCOPE } from "../constants/news.constants";
import type { NewsNote } from "../types/news.types";

export function canCreateNote(user: UserEntity | null | undefined): boolean {
  if (!user?.scopes?.length) return false;
  return NOTES_CREATE_SCOPES.some((scope) => user.scopes.includes(scope));
}

export function canDeleteNote(user: UserEntity | null | undefined, note: NewsNote): boolean {
  if (!user?.id) return false;
  if (user.id === note.createdByUserId) return true;
  if (user.role === "admin" && user.scopes?.includes(NOTES_MODERATE_SCOPE)) return true;
  return false;
}
